import React, { Component } from 'react';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import FirstPageDebitCreditNoteEntry from '../../components/account/DebitCreditNoteEntry/FirstPageDebitCreditNoteEntry.js';
import SecondPageDebitCreditNoteEntry from '../../components/account/DebitCreditNoteEntry/SecondPageDebitCreditNoteEntry.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import moment from 'moment';
import { encryptionAPI } from '../../utils/Encryption.js';
import { APIURL } from '../../utils/AppSetting.js';
import { GenerateCreditNoteEntryById } from '../../services/axioServices/ApiEndPoints.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';

class GeneralCreditNoteEntry extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            pageName: "CreditNoteEntry",
            isGridView: true,
            isEditing: false,
            generalCreditNoteList: [],
            isLoading: "",
            tableStatus: "",
            filterDetails: {
                partyName: "",
                arrangedBy: "Select",

            },
            invoiceDetails: {
                generalCreditNoteId: "",
                noteNo: "",
                date: "",
                partyId: "",
                partyGstnNo: "",
                hsnSac: "",
                acName: "",
                acNarration1: "",
                acNarration2: "",
                selfIssue: "",
                gstApply: "",
                rcm: "",
                hsnSacCode: "",
                sgst: "",
                cgst: "",
                igst: "",
                ugst: "",
                hsnDescription: "",
                sgstAmount: "",
                cgstAmount: "",
                igstAmount: "",
                ugstAmount: "",
                description1: "",
                description2: "",
                description3: "",
                description4: "",
                description5: "",
                amount1: "",
                amount2: "",
                amount3: "",
                amount4: "",
                amount5: "",
                subTotal: "",
                grandTotal: "",
                roundOff: ""
            },
            partyDropdownList: [],
            arrangedByList: [
                { arrangedBy: "Ser. No.", value: "serNo" },
                { arrangedBy: "Date", value: "date" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Net Amount", value: "grandTotal" },

            ],
            List: [
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
            ],
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                acId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "a/c name"
                        ),
                    },
                ],
                hsnSacCode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "hsn/sac code"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllGeneralCreditNoteEntry()
    }

    getAllGeneralCreditNoteEntry = () => {
        this.setState({ tableStatus: "Loading..." },)
        let request = this.state.filterDetails
        this.accountServices.getAllGeneralCreditNoteEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ generalCreditNoteList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    gstNo: item.gstnNo
                }));
                this.setState({ partyDropdownList: dropdownItems });
            } else {

                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.invoiceDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails;
        Fdetails.partyName = "";
        Fdetails.arrangedBy = "serNo";
        let Idetails = this.state.invoiceDetails;
        Idetails.generalCreditNoteId = "";
        Idetails.noteNo = "";
        Idetails.date = "";
        Idetails.partyId = "";
        Idetails.PartyGstnNo = "";
        Idetails.hsnSac = "";
        Idetails.acName = "";
        Idetails.acNarration1 = "";
        Idetails.acNarration2 = "";
        Idetails.selfIssue = "";
        Idetails.gstApply = "";
        Idetails.rcm = "";
        Idetails.hsnSacCode = ""
        Idetails.sgst = ""
        Idetails.cgst = "";
        Idetails.igst = "";
        Idetails.hsnDescription = "";
        Idetails.cgstAmount = ""
        Idetails.sgstAmount = ""
        Idetails.igstAmount = ""
        Idetails.description1 = ""
        Idetails.description2 = ""
        Idetails.description3 = ""
        Idetails.description4 = ""
        Idetails.description5 = ""
        Idetails.amount1 = ""
        Idetails.amount2 = ""
        Idetails.amount3 = ""
        Idetails.amount4 = ""
        Idetails.amount5 = ""
        Idetails.subTotal = ""
        Idetails.grandTotal = ""

        this.setState({
            invoiceDetails: Idetails, filterDetails: Fdetails, validState: validState, isEditing: false
        }, () => {
            this.getAllGeneralCreditNoteEntry()
        });
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllGeneralCreditNoteEntry()
            })
        }
        else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = value.toUpperCase();
            this.setState({ invoiceDetails: details }, () => {
                this.calculateGrandTotal()
            });
        }
    };

    calculateGrandTotal = () => {
        let details = this.state.invoiceDetails
        details.subTotal = Number(details.amount1) + Number(details.amount2) + Number(details.amount3) + Number(details.amount4) + Number(details.amount5)
        details.sgstAmount = (Number(details.sgst) * Number(details.subTotal) / 100).toFixed(2)
        details.cgstAmount = (Number(details.cgst) * Number(details.subTotal) / 100).toFixed(2)
        details.igstAmount = (Number(details.igst) * Number(details.subTotal) / 100).toFixed(2)
        details.ugstAmount = (Number(details.ugst) * Number(details.subTotal) / 100).toFixed(2)
        details.grandTotal = (Number(details.subTotal) + Number(details.sgstAmount) + Number(details.cgstAmount) + Number(details.ugstAmount) + Number(details.igstAmount)).toFixed(2)
        details.grandTotal = Number(details.grandTotal)
        details.roundOff = (Number(details.grandTotal) % 1).toFixed(2);
        details.grandTotal = Math.floor(details.grandTotal).toFixed(2);
        this.setState({ invoiceDetails: details })
    }

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllGeneralCreditNoteEntry()
            })
        }
        else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = select;
            this.setState({ invoiceDetails: details }, () => {
                if (this.state.invoiceDetails.gstApply === 'no') {
                    let details = this.state.invoiceDetails
                    details.sgst = 0
                    details.cgst = 0
                    details.igst = 0
                    details.ugst = 0
                    details.sgstAmount = 0
                    details.cgstAmount = 0
                    details.igstAmount = 0
                    details.ugstAmount = 0
                    this.setState({ invoiceDetails: details })
                }
            });
        }
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.invoiceDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.partyGstnNo = selected.gstNo
        }
        this.setState({ invoiceDetails: details });
    };

    getGeneralCreditNoteEntrySRNo = () => {
        this.accountServices.getGeneralCreditNoteEntrySRNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.invoiceDetails
                details.noteNo = response.responseData.noteNo
                details.date = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ invoiceDetails: details, isEditing: false }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    addEditGeneralCreditNoteEntry = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ isLoading: "save" }, () => {
                let request = this.state.invoiceDetails
                this.accountServices.addEditGeneralCreditNoteEntry(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let details = this.state.invoiceDetails
                        details.generalCreditNoteId = response.responseData._id
                        this.SwalServices.Success(response.Message);
                        this.setState({ isGridView: true, invoiceDetails: details, isLoading: "" }, () => {
                            this.resetForm()
                            this.getAllGeneralCreditNoteEntry()
                        })
                    } else {
                        this.setState({ isLoading: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    getGeneralCreditNoteEntryById = (id) => {
        this.accountServices.getGeneralCreditNoteEntryById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.invoiceDetails
                details.noteNo = res.noteNo
                details.generalCreditNoteId = res._id
                details.partyId = res.partyId._id
                details.date = moment(res.date).format('yyyy-MM-DD')
                details.partyGstnNo = res.partyGstnNo
                details.hsnSac = res.hsnSac
                details.acId = res.acId
                details.acNarration1 = res.acNarration1
                details.acNarration2 = res.acNarration2
                details.gstApply = res.gstApply
                details.selfIssue = res.selfIssue
                details.rcm = res.rcm
                details.description1 = res.description1
                details.description2 = res.description2
                details.description3 = res.description3
                details.description4 = res.description4
                details.description5 = res.description5
                details.amount1 = res.amount1
                details.amount2 = res.amount2
                details.amount3 = res.amount3
                details.amount4 = res.amount4
                details.amount5 = res.amount5
                details.hsnSacCode = res.hsnSacCode
                details.hsnDescription = res.hsnDescription
                details.sgst = res.sgst
                details.cgst = res.cgst
                details.igst = res.igst
                details.ugst = res.ugst
                details.sgstAmount = res.sgstAmount
                details.cgstAmount = res.cgstAmount
                details.igstAmount = res.igstAmount
                details.ugstAmount = res.ugstAmount
                details.subTotal = res.subTotal
                details.grandTotal = Number(res.grandTotal).toFixed(2)
                details.roundOff = res.roundOff
                this.setState({ invoiceDetails: details }, () => {
                    this.setState({ isGridView: false, isEditing: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteGeneralCreditNoteEntryById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this General Credit Note Entry?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteGeneralCreditNoteEntryById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllGeneralCreditNoteEntry()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }


    generateCreditNoteEntryById = () => {
        this.setState({ isLoading: "print" }, () => {
            let loginUser = getAuthProps();
            let headers = {
                Authorization: `Bearer ${loginUser.token}`,
                dbYear: loginUser.dbYear
            };
            let id = this.state.invoiceDetails.generalCreditNoteId
            let encryptId = encryptionAPI(id, 0)
            fetch(`${APIURL + GenerateCreditNoteEntryById}?id=${encryptId}`, {
                method: 'GET',
                headers: headers
            })
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isLoading: "" })
                })
        })
    }

    render() {
        return (

            <div className='GeneralDebitNoteEntry-page' >
                {
                    this.state.isGridView === true ? (
                        <FirstPageDebitCreditNoteEntry
                            filterDetails={this.state.filterDetails}
                            arrangedByList={this.state.arrangedByList}
                            handleChange={this.handleChange.bind(this)}
                            handleDropDownChange={this.handleDropDownChange.bind(this)}
                            closeGridView={this.closeGridView.bind(this)}
                            pageName={this.state.pageName}
                            tableStatus={this.state.tableStatus}
                            getGeneralDebitNoteEntrySRNo={this.getGeneralCreditNoteEntrySRNo.bind(this)}
                            generalDebitNoteList={this.state.generalCreditNoteList}
                            getCreditDebitNoteEntryById={this.getGeneralCreditNoteEntryById.bind(this)}
                            deleteCreditDebitNoteEntryById={this.deleteGeneralCreditNoteEntryById.bind(this)}
                        />
                    ) : null
                }


                {this.state.isGridView === false ? (
                    <SecondPageDebitCreditNoteEntry
                        pageName={this.state.pageName}
                        List={this.state.List}
                        invoiceDetails={this.state.invoiceDetails}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        setFilterParameters={this.setFilterParameters.bind(this)}
                        partyDropdownList={this.state.partyDropdownList}
                        openGridView={this.openGridView.bind(this)}
                        validationRules={this.state.validationRules}
                        validState={this.state.validState}
                        addEditGeneralDebitNoteEntry={this.addEditGeneralCreditNoteEntry.bind(this)}
                        isEditing={this.state.isEditing}
                        generalCreditDebitNoteId={this.state.invoiceDetails.generalCreditNoteId}
                        generateDebitNoteEntryById={this.generateCreditNoteEntryById.bind(this)}
                        isLoading={this.state.isLoading}
                    />
                ) : null
                }
            </div >
        );
    }
}

export default GeneralCreditNoteEntry;